import React, { FC } from 'react';
import Form from 'components/Form';

import { NurofenPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Nurofen: FC<NurofenPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Nurofen;
